import brandColors from 'main/hotelBrandColors.json'
import { useSelector } from 'react-redux'
import { getForegroundColor } from 'utils/colorHelpers'

const BASE_LOGO_URL = 'https://cdn.swaypay.io/logos/brands/'

/**
 *
 * @typedef Params
 * @property {string} subsidiaryShortLinkToken
 * @property {string} parentChainCode
 *
 * @param {(Params | undefined)} params
 * @returns
 */
function useBrand(params) {
  const subsidiaryShortLinkToken = useSelector(
    s => s.hotelDetails.subsidiaryShortLinkToken
  )

  let brand = subsidiaryShortLinkToken.split('/')[0]
  let parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)

  if (params) {
    brand = params.subsidiaryShortLinkToken.split('/')[0]
    parentChainCode = params.parentChainCode
  }

  const colors = brandColors?.[parentChainCode]?.[brand] ?? brandColors.fallback

  const logoUrl = BASE_LOGO_URL + brand + '.png'

  const actionText = getForegroundColor(colors.action)
  const primaryText = getForegroundColor(colors.primary)

  return { brand, colors: { ...colors, actionText, primaryText }, logoUrl }
}

export default useBrand
